// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Xqiw","approved":"Status_approved__1POu3","rejected":"Status_rejected__98CzV","expired":"Status_expired__3tvbK","label":"Status_label__2kXJD"};